import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE = "https://parastousaba.com";

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const clean = pathname === "/" ? "" : pathname.replace(/\/+$/, "");
    const url = BASE + clean;
    const canonical = document.head.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", url);
    const ogUrl = document.head.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", url);
  }, [pathname]);

  return null;
}
